import * as React from "react";
import {cx} from "emotion";

import "./base-card-modal.scss";

import {cs}                from "@Common/react/chain-services";
import {keyed}             from "@Common/react/keyed";
import {UseState}          from "@Common/react/use-state";
import {ConfirmExitDialog} from "@Common/ui-components/dialogs/confirm-exit-dialog";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {chain}             from "@Common/utils/fs";

import {Breadcrumbs2} from "../../../../../common/breadcrumbs2/breadcrumbs2";

export const BaseCardModal = ({renderSteps, title, action, getInitCard = undefined, apisAddUpdate, next: rootNext}) => cs(
    ["confirmClose", (_, next) => ConfirmExitDialog({next})],
    ["modal", ({confirmClose}, next) => ModalService3({
        onPassiveClose: confirmClose,
        // initShow: true,
        top: 10,
        width: 473,
        xdQaName: "Credit Card Modal",
        rootNext,
        next,
    })],
    ["steps", ({modal}, next) => renderSteps({next, params: modal.params})],
    ["userStepIndex", (_, next) => UseState({initValue: 0, next})],
    ["activeIndex", ({steps, userStepIndex}, next) => next(Math.min(userStepIndex.value, steps.findIndex((s) => !s.ready)))],
    ["step", ({steps, activeIndex}, next) => next(steps[activeIndex])],
    ({modal, step,steps, activeIndex, userStepIndex, confirmClose}) => (
        <div className="base-card-modal-2r2">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Title">
                    {title}
                </div>

                {Breadcrumbs2({
                    steps: steps.map((s, i) => ({
                        label: "Step " + (i+1),
                        active: activeIndex===i,
                        onSelect: () => userStepIndex.onChange(i),
                        disabled: steps.slice(0, i).find((s) => !s.ready),
                    })),
                    style: {
                        stepMinWidth: 76,
                    },
                })}
            </div>

            <div className="content">
                {cs(
                    keyed(activeIndex),
                    () => step.render(),
                )}
            </div>

            <div className="footer">
                <button
                    className="cancel"
                    onClick={async () => {
                        if (await confirmClose()) {
                            modal.close();
                        }
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Cancel"
                >
                    Cancel
                </button>

                {cs(
                    ["submitting", (_, next) => UseState({next})],
                    ({submitting}) => (
                        <button
                            className={cx("next", {
                                // disabled: submitting.value || !shippingAddressForm.form.validate(),
                                disabled: step.action.disabled,
                            })}
                            disabled={submitting.value}
                            onClick={async () => {
                                if (step.action.disabled) {
                                    step.action.clickedWhenDisabled?.();
                                    return;
                                }

                                const submit = async () => {
                                    const card = chain(
                                        getInitCard?.({params: modal.params}) ?? {},
                                        ...steps.map((s) => s.modCard),
                                    );

                                    submitting.onChange(true);
                                    try {
                                        await apisAddUpdate(card);
                                        await modal.params.onDone?.(card);
                                        modal.close();
                                    } catch (e) {
                                        step.action.onSubmitError(e);
                                    } finally {
                                        submitting.onChange(false);
                                    }

                                };

                                await step.action.onClick({submit});
                                userStepIndex.onChange(activeIndex + 1);
                            }}
                            xd-qa-type="button"
                            xd-qa-name={submitting.value ? (
                                action.submittingLabel
                            ) : (
                                step.action.label ?? action.label
                            )}
                        >
                            {submitting.value ? (
                                action.submittingLabel
                            ) : (
                                step.action.label ?? action.label
                            )}
                        </button>
                    )
                )}
            </div>
        </div>
    ),
);
